import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PRODUCTS } from '../models/products'; // Ton tableau de produits


@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {

  product: any;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const idProduct = params['p'].toString();

      console.log(PRODUCTS, idProduct) ;

      if (idProduct) {
        this.product = PRODUCTS.find(p => p.id.toString() === idProduct);
      }
    });
  }

  playAudio() {
    const audio = new Audio(this.product.audioUrl);
    audio.play();
  }

  openWhatsApp() {
    const message = `Bonjour, je suis intéressé par le produit : ${this.product.name}`;
    const url = `https://wa.me/2250700000000?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }
  
}
